//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant';
export default {
  data () {
    return {
      form: this.$form.createForm(this, 'form'),
      visible: false,
      userPhone: '',
      password: '',
      timeFlag: false,
      second: 59,
      timer: null
    }
  },
  methods: {
    showLogin () {
      this.visible = true
    },
    fnSendSms() { // 发送验证码
      if(this.userPhone == ''){
        Toast('请输入手机号')
        return
      }
      let param = {
          smsType: 0,
          smsPhone: this.userPhone
      }
      let checkParam = {
        userPhone: this.userPhone,
      };
      // 调用发验证码接口
      this.$store.dispatch('fnNoCheckSmsSendSmsCode',JSON.stringify(param)).then(res=>{
        if(res.data.retCode == 1){
          this.fnHandleTimer()
        }else{
          Toast(res.data.retMsg)
        }
      })
    },
    btnOkClicked () {
      if(this.fnCheckForm()){
        let param = {
          loginType: 0,
          userPhone: this.userPhone,
          password: this.password,
          createType: 0,
          bindWechar: 0,
          realState: 0,
          safetyLevel: 0,
          isLogin: 0,
          autoRegister: 1
        }
        this.$store.dispatch('user/fnLoginNoCheckDoLogin',JSON.stringify(param)).then(res=>{
          if(res.data.retCode == 1){
            Toast('登录成功')
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.fnHandleUser(res.data.obj)
          }else{
            Toast(res.data.retMsg)
          }
        })
      }
    },
    fnHandleUser(obj) { // 处理登录后用户信息
      // 保存到token中
      this.$store.commit('setUserInfo',obj)
      this.$emit('lognSucccess', obj)
      this.visible = false
      this.$nextTick(()=>{
        localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
      })
    },
    fnCheckForm() { // 验证表单
      if(this.userPhone == ''){
        Toast('请输入手机号')
        return false
      }
      if(this.password == ''){
        Toast('请输入验证码')
        return false
      }
      return true
    },
    btnCancleClicked () {
      this.fnClose()
    },
    fnClose () {
      this.userPhone = ''
      this.password = ''
      this.timeFlag = false
      this.second = 59
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    fnHandleTimer() { // 处理验证码
      let maxSecond = 60
      this.timeFlag = true
      this.timer = setInterval(() => {
       if (this.second > 0 && this.second <= maxSecond) {
         this.second--
        } else {
         this.timeFlag = false
         this.second = 59
         clearInterval(this.timer)
        }
       }, 1000)
    },
    fnGetPhoneRegx () {
      return /^[0-9]{11,13}$/
    }
  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/product/quoLoginModule.vue